import { Pages } from '@/consts/routes'

interface PathGroup {
  patterns: string[]
  helpDeskLink?: string
  helpDeskLinkName: string
}

export const HELP_DESK_ARTICLES: PathGroup[] = [
  // Welcome Messages
  {
    patterns: [
      Pages.WELCOME_MESSAGES_OPTIONS,
      Pages.WELCOME_MESSAGES_CREATE,
      Pages.WELCOME_MESSAGES_EDIT,
    ],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10498179-welcome-messages',
    helpDeskLinkName: 'Welcome Messages Guide',
  },

  // Home
  {
    patterns: [
      Pages.HOME,
      Pages.OVERVIEW,
      Pages.CHATTER_LEADERBOARD_BROWSER,
      Pages.CHATTER_LEADERBOARD_USER,
    ],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10378999-overview-page',
    helpDeskLinkName: 'Overview Guide',
  },
  // BLACKLISTED_WORDS
  {
    patterns: [Pages.BLACKLISTED_WORDS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10423557-blacklisted-words',
    helpDeskLinkName: 'Blacklisted Words Guide',
  },

  {
    patterns: [Pages.BLACKLISTED_WORDS_LOGS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10423568-blocked-messages-log',
    helpDeskLinkName: 'Blocked Messages Log Guide',
  },

  // Prospects
  {
    patterns: [Pages.PROSPECTS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10551860-prospecting-feature',
    helpDeskLinkName: 'Prospecting Guide',
  },

  // Creators
  {
    patterns: [Pages.CREATORS, Pages.CREATOR_ACCESS],
    helpDeskLink: 'https://help.creatorhero.com/en/articles/10408614-creators',
    helpDeskLinkName: 'Creators Guide',
  },

  // Team
  {
    patterns: [Pages.TEAM, Pages.TEAM_MEMBERS],
    helpDeskLink: 'https://help.creatorhero.com/en/articles/10377593-team-page',
    helpDeskLinkName: 'Team Guide',
  },
  {
    patterns: [Pages.TEAM_MEMBER_DETAILS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10379125-edit-team-members',
    helpDeskLinkName: 'Team Members Guide',
  },
  {
    patterns: [Pages.TEAM_ROLES, Pages.TEAM_ROLE_EDIT],
    helpDeskLink: 'https://help.creatorhero.com/en/articles/10398444-roles',
    helpDeskLinkName: 'Team Roles Guide',
  },

  // Shifts
  {
    patterns: [Pages.SHIFTS],
    helpDeskLink: 'https://help.creatorhero.com/en/articles/10423267-shifts',
    helpDeskLinkName: 'Shifts Guide',
  },
  {
    patterns: [Pages.SHIFTS_HISTORY],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10423350-shifts-history',
    helpDeskLinkName: 'Shifts History Guide',
  },

  // Creator Tracking
  {
    patterns: [Pages.CREATOR_TRACKING_NEW_SUBSCRIBER],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10492675-new-subscriber-analysis',
    helpDeskLinkName: 'New Subscriber Analysis Guide',
  },
  {
    patterns: [
      Pages.CREATOR_TRACKING_CHATTER,
      Pages.CREATOR_TRACKING_CHATTER_DETAILS,
    ],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10426384-chatter-tracking',
    helpDeskLinkName: 'Chatter Tracking Guide',
  },
  {
    patterns: [
      Pages.CREATOR_TRACKING_PPV,
      Pages.CREATOR_TRACKING_PPV_DETAILS,
      Pages.CREATOR_TRACKING_PPV_MESSAGES,
    ],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10492637-ppv-tracking',
    helpDeskLinkName: 'PPV Tracking Guide',
  },
  {
    patterns: [
      Pages.CREATOR_TRACKING_LINKS,
      Pages.CREATOR_TRACKING_LINKS_DETAILS,
    ],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10495787-tracking-links',
    helpDeskLinkName: 'Tracking Links Guide',
  },
  {
    patterns: [
      Pages.CREATOR_TRACKING_FREE_TRIAL_LINKS,
      Pages.CREATOR_TRACKING_FREE_TRIAL_LINKS_DETAILS,
    ],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10497982-free-trail-links',
    helpDeskLinkName: 'Free Trial Links Guide',
  },
  {
    patterns: [Pages.CREATOR_TRACKING_MESSAGE_HISTORY],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10498134-message-history',
    helpDeskLinkName: 'Message History Guide',
  },
  {
    patterns: [
      Pages.CREATOR_TRACKING_FUNNEL,
      Pages.CREATOR_TRACKING_FUNNEL_DETAILS,
    ],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10423588-funnel-monitoring',
    helpDeskLinkName: 'Funnel Monitoring Guide',
  },
  {
    patterns: [
      Pages.CREATOR_TIKTOK_RESEARCH_VIDEOS,
      Pages.CREATOR_TIKTOK_RESEARCH_SOUNDS,
      Pages.CREATOR_TIKTOK_RESEARCH_SOUND_PAGE,
      Pages.CREATOR_TIKTOK_RESEARCH_LISTS,
      Pages.CREATOR_TIKTOK_RESEARCH_LIST_PAGE,
    ],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/11575926-tiktok-research',
    helpDeskLinkName: 'TikTok Research Guide',
  },

  // Creator Statistics
  {
    patterns: [Pages.CREATOR_STATISTICS_TIKTOK],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10433519-tiktok-statistics',
    helpDeskLinkName: 'TikTok Statistics Guide',
  },
  {
    patterns: [Pages.CREATOR_STATISTICS_TIKTOK_ACCOUNTS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10434081-tiktok-manage-accounts',
    helpDeskLinkName: 'TikTok Accounts Guide',
  },
  {
    patterns: [Pages.CREATOR_STATISTICS_ONLYFANS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10423511-onlyfans-statistics',
    helpDeskLinkName: 'OnlyFans Statistics Guide',
  },
  {
    patterns: [Pages.CREATOR_STATISTICS_IG_REELS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10433173-instagram-reels-statistics',
    helpDeskLinkName: 'Instagram Reels Statistics Guide',
  },
  {
    patterns: [Pages.CREATOR_STATISTICS_IG_REELS_ACCOUNTS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10433781-instagram-manage-accounts',
    helpDeskLinkName: 'Instagram Accounts Guide',
  },

  // Creator AI
  {
    patterns: [Pages.CREATOR_AI_SETTINGS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10514420-ai-settings',
    helpDeskLinkName: 'AI Translator Guide',
  },

  // Creator Automations
  {
    patterns: [
      Pages.CREATOR_SETTINGS_PROMOTION,
      Pages.CREATOR_SETTINGS_AUTO_FOLLOW,
    ],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10379174-automations',
    helpDeskLinkName: 'Automations Guide',
  },
  {
    patterns: [Pages.CREATOR_SETTINGS_FAN_NUMBERING],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10381049-fan-numbering',
    helpDeskLinkName: 'Fan Numbering Guide',
  },

  // Creator Scripts
  {
    patterns: [
      Pages.CREATOR_SCRIPTS,
      Pages.CREATOR_SCRIPTS_CREATE,
      Pages.CREATOR_SCRIPTS_EDIT,
    ],
    helpDeskLink: 'https://help.creatorhero.com/en/articles/10514438-scripts',
    helpDeskLinkName: 'Scripts Guide',
  },

  // Creator Messages
  {
    patterns: [Pages.CREATOR_PPV_FOLLOW_UP_MESSAGES],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10499966-ppv-follow-ups',
    helpDeskLinkName: 'PPV Follow-ups Guide',
  },
  {
    patterns: [
      Pages.CREATOR_REBILL_MESSAGES,
      Pages.CREATOR_REBILL_MESSAGES_CREATE,
      Pages.CREATOR_REBILL_MESSAGES_EDIT,
    ],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10498189-rebill-messages',
    helpDeskLinkName: 'Rebill Messages Guide',
  },
  {
    patterns: [
      Pages.CREATOR_ONLINE_MASS_MESSAGES,
      Pages.CREATOR_ONLINE_MASS_MESSAGES_CREATE,
    ],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10512877-online-mass-messages',
    helpDeskLinkName: 'Online Mass Messages Guide',
  },
  {
    patterns: [Pages.CREATOR_EXPIRING_FANS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/11102180-expiring-fans',
    helpDeskLinkName: 'Expiring Fans Guide',
  },

  // Creator Lists
  {
    patterns: [Pages.CREATOR_SPENDING_LISTS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/11101979-fan-spend-lists',
    helpDeskLinkName: 'Fan Spend Lists Guide',
  },
  {
    patterns: [Pages.CREATOR_NEW_SUBS_LIST],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10426403-new-subs-list',
    helpDeskLinkName: 'New Subs List Guide',
  },
  {
    patterns: [Pages.CREATOR_NO_SPENDERS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10522947-no-spender-list',
    helpDeskLinkName: 'No Spender List Guide',
  },
  {
    patterns: [Pages.CREATOR_RECENT_SPENDERS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10522981-recent-spend-list',
    helpDeskLinkName: 'Recent Spend List Guide',
  },
  {
    patterns: [Pages.CREATOR_SHARED_FOLLOWERS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10518599-shared-following-list',
    helpDeskLinkName: 'Shared Following List Guide',
  },
  {
    patterns: [Pages.CREATOR_CUSTOM_LISTS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10523129-custom-lists',
    helpDeskLinkName: 'Custom Lists Guide',
  },

  // Creator Settings
  {
    patterns: [Pages.CREATOR_DISPLAY_SETTINGS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10434184-display-settings',
    helpDeskLinkName: 'Display Settings Guide',
  },
  {
    patterns: [Pages.CREATOR_AUTOMATION_SETTINGS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10381877-automation-settings',
    helpDeskLinkName: 'Automation Settings Guide',
  },
  {
    patterns: [Pages.CREATOR_VISIBILITY_SETTINGS],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10434129-visibility-settings',
    helpDeskLinkName: 'Visibility Settings Guide',
  },
  {
    patterns: [Pages.CREATOR_VAULT],
    helpDeskLink: 'https://help.creatorhero.com/en/articles/10461326-vault',
    helpDeskLinkName: 'Vault Guide',
  },

  // Licenses
  {
    patterns: [Pages.LICENSES, Pages.YOUR_LICENSES],
    helpDeskLink: 'https://help.creatorhero.com/en/articles/10461265-licences',
    helpDeskLinkName: 'Licenses Guide',
  },

  // Help
  {
    patterns: [Pages.VIP_SUPPORT],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10498110-personal-assistant',
    helpDeskLinkName: 'Vip Support Guide',
  },

  // Accounting
  {
    patterns: [Pages.ACCOUNTING],
    helpDeskLink:
      'https://help.creatorhero.com/en/articles/10523199-accounting-site',
    helpDeskLinkName: 'Accounting Guide',
  },
]
